import React from "react";
import { useSelector } from "react-redux";
import createAnimationSelectedTabSelector from "selectors/createAnimationSelectedTab";
import AnimationTypeSelectorSection from "./AnimationTypeSelectorSection";
import DownloadAnimationSection from "./DownloadAnimationSection";
import ReviewAnimationSection from "./ReviewAnimationSection";
import UploadVideoSection from "./UploadVideoSection";
import UseAnimationSection from "./UseAnimationSection";

const AnimationBody: React.FC = () => {
    const selectedTab = useSelector(createAnimationSelectedTabSelector);

    if (selectedTab === 0) {
        return <AnimationTypeSelectorSection />;
    } else if (selectedTab === 1) {
        return <UploadVideoSection />;
    } else if (selectedTab === 2) {
        return <ReviewAnimationSection />;
    } else if (selectedTab === 3) {
        return <DownloadAnimationSection />;
    } else {
        return <UseAnimationSection />;
    }
};

export default AnimationBody;
